export const LOADING_MODES = {
  auto: "",
  dark: "dark",
  light: "light",
} as const

export type LoadingModesType = keyof typeof LOADING_MODES
